import { render } from "./ArticlePage.vue?vue&type=template&id=ec12f0be"
import script from "./ArticlePage.vue?vue&type=script&lang=js"
export * from "./ArticlePage.vue?vue&type=script&lang=js"

import "./ArticlePage.vue?vue&type=style&index=0&id=ec12f0be&lang=css"
import "./ArticlePage.vue?vue&type=style&index=1&id=ec12f0be&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__